var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                "grid-options": _vm.gridOptions,
                "grid-params": _vm.gridParams,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                },
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        )
      ]),
      _c("picture-view-window", {
        attrs: {
          visible: _vm.pictureView.visible,
          job: _vm.job,
          model: _vm.pictureView.model,
          title: _vm.pictureView.title,
          "file-name": _vm.pictureView.fileName,
          type: _vm.pictureView.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.pictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }